<template>
  <label class="checkboxes" tabindex="0"
         v-on:keypress.space.enter="isPressed">
    <div v-html="label" />
    <input type="checkbox"
           id="emailsChecked"
           v-model="checked" />
    <span class="checkmark cursor-pointer"
          :class="{'checkbox-emails' : error && !checked }"
          :qa="qaClass">
      <i class="fal fa-check" />
    </span>
  </label>
</template>

<script>

export default {
  props: ['label', 'error', 'qaClass'],
  data: function () {
    return {
      checked: false
    }
  },
  watch: {
    checked: function (value) {
      this.$emit('input', value)
    }
  },
  methods: {
    isPressed: function () {
      this.checked = !this.checked
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

  .checkboxes {
    position: relative;
    text-align: left;
    padding-left: 45px;
    margin-top: 10px;
    margin-bottom: 10px;
    width: 100%;
    display: block;

    // hide browser default checkbox
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    input {
      display: none;
    }

    label {
      font-weight: 600;
      font-size: .9rem;
      display: inline;
      position: relative;
    }

    .checkmark {
      position: absolute;
      top: 1px;
      left: -30px;
      height: 25px;
      width: 25px;
      margin-left: 35px;
      background-color: white;
      border: 3px solid gray;
      i {
        display: none;
        color: white;
        text-align: center;
        margin-top: 2.5px;
        font-size: 1rem;
      }
      &:hover {
         background-color: #ccc;
       }
      &:after {
         content: '';
         position: absolute;
       }
    }

    input:checked ~ .checkmark {
      i {
        display: block;
      }
      background-color: $primary;
    }
    input:checked ~ .checkmark:after {
      display: block;
    }
  }

  .checkbox-positive,
  .checkbox-emails {
    border: $primary 3px solid;
  }
</style>
